(function () {
  if (window.__restockNotificationInit) return;
  window.__restockNotificationInit = true;

  var ENDPOINT = '/apps/computer-orbit-shopify/stock-subscribe';

  function getFormVariantId(scope) {
    if (!scope) return null;
    var field = scope.querySelector('[name="id"]');
    if (!field) return null;
    var value = Number(field.value);
    return isNaN(value) ? null : value;
  }

  function setFilledState(input) {
    if (!input) return;
    if (input.value && input.value.trim() !== '') {
      input.classList.add('form-field-filled');
    } else {
      input.classList.remove('form-field-filled');
    }
  }

  function initWidget(widget) {
    if (widget.__restockReady) return;
    widget.__restockReady = true;

    var form = widget.closest('form');
    var scope = form || document;
    var variantSelection = scope.querySelector('[data-variant-selection]');
    var emailInput = widget.querySelector('[data-restock-email]');
    var submitButton = widget.querySelector('[data-restock-submit]');
    var message = widget.querySelector('[data-restock-message]');

    if (!emailInput || !submitButton || !message) return;

    var selectedVariantId = getFormVariantId(scope);

    function setVisible(visible) {
      widget.hidden = !visible;
    }

    function setMessage(text, type) {
      message.textContent = text || '';
      message.classList.remove(
        'restock-signup__message--error',
        'restock-signup__message--success',
        'restock-signup__message--enter'
      );
      if (type === 'error') message.classList.add('restock-signup__message--error');
      if (type === 'success') message.classList.add('restock-signup__message--success');
      if (text) {
        // Restart the entrance animation each time a new message is shown.
        void message.offsetWidth;
        message.classList.add('restock-signup__message--enter');
      }
    }

    function setLoading(loading) {
      submitButton.disabled = loading;
      submitButton.classList.toggle('processing', loading);
      if (loading) {
        submitButton.setAttribute('aria-busy', 'true');
      } else {
        submitButton.removeAttribute('aria-busy');
      }
    }

    setFilledState(emailInput);
    emailInput.addEventListener('input', function () {
      setFilledState(emailInput);
    });
    emailInput.addEventListener('blur', function () {
      setFilledState(emailInput);
    });

    // Prevent Enter in the email field from submitting the product form.
    emailInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        submit();
      }
    });

    if (variantSelection) {
      variantSelection.addEventListener('variant-change', function (event) {
        var variant = event.detail && event.detail.variant;

        // The element also emits this event with no variant (e.g. on init for a
        // default-variant product, or when nothing is selected). In that case the
        // server-rendered visibility is authoritative, so leave it untouched.
        if (!variant) return;

        selectedVariantId = variant.id ? Number(variant.id) : getFormVariantId(scope);
        setVisible(variant.available === false);
        setMessage('');
      });
    }

    function submit() {
      var email = (emailInput.value || '').trim();

      if (!email) {
        setMessage('Please enter your email address.', 'error');
        emailInput.focus();
        return;
      }

      var variantId = selectedVariantId || getFormVariantId(scope);

      setLoading(true);
      setMessage('');

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, variant_id: variantId })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || !result.data || !result.data.success) {
            throw new Error(
              (result.data && result.data.error) || 'Could not save stock notification.'
            );
          }
          setMessage(
            "Thanks! We'll email you when this is back in stock.",
            'success'
          );
          emailInput.value = '';
          setFilledState(emailInput);
        })
        .catch(function (error) {
          setMessage(error.message || 'Could not save stock notification.', 'error');
        })
        .then(function () {
          setLoading(false);
        });
    }

    submitButton.addEventListener('click', submit);
  }

  function initAll() {
    var widgets = document.querySelectorAll('[data-restock-signup]');
    for (var i = 0; i < widgets.length; i++) {
      initWidget(widgets[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
